/** Backend enum-style names, e.g. `INSTITUTE_ADMIN` or `DOCTOR`. */
const ENUM_NAME = /^[A-Z0-9]+(?:_[A-Z0-9]+)*$/;

/**
 * Display label for a role. System roles come back as enums
 * (`INSTITUTE_ADMIN` → "Institute Admin"); user-created role names are shown
 * exactly as typed. Display only — always send `role.name` to the API.
 */
export const getRoleDisplayName = (role: {
  name: string;
  is_system?: boolean;
}): string => {
  if (!role.is_system || !ENUM_NAME.test(role.name)) return role.name;
  return role.name
    .split("_")
    .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
    .join(" ");
};
